import { render, staticRenderFns } from "./PageRecurring.vue?vue&type=template&id=25739898&"
import script from "./PageRecurring.vue?vue&type=script&lang=ts&"
export * from "./PageRecurring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports